export const actionTypes = {
  SHOW_ONBOARDING_POPUP: 'SHOW_ONBOARDING_POPUP',
  HIDE_ONBOARDING_POPUP: 'HIDE_ONBOARDING_POPUP',
};

const showOnboardingPopup = ({ type }) => ({
  type: actionTypes.SHOW_ONBOARDING_POPUP,
  payload: { type },
});

const hideOnboardingPopup = () => ({
  type: actionTypes.HIDE_ONBOARDING_POPUP,
});

export { showOnboardingPopup, hideOnboardingPopup };
